/* eslint-disable react/jsx-no-undef */
import React, { useState } from "react";
import Heading from "../../components/Heading";
import "./style.scss";
import PRSList from "./PRSList";
import { Tabs } from "antd";

const PRS = () => {
  const [activeKey, setActiveKey] = useState("1");
  const [tabValue, setTabValue] = useState("unassigned");
  const onChange = (key) => {
    setActiveKey(key);
    setTabValue(key === "1" ? "unassigned" : "all");
  };

  return (
    <div className="p-1">
      <Heading title="PRS" />
      <div className="global-card-tab-container">
        <Tabs
          defaultActiveKey="1"
          activeKey={activeKey}
          onChange={onChange}
          items={[
            {
              label: "Unassigned",
              key: "1",
              children: <PRSList tabValue={tabValue} />,
            },
            {
              label: "All",
              key: "2",
              children: <PRSList tabValue={tabValue} />,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default PRS;
